/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
-----------------------------------------------------------------------------*/

<template>
  <div
    class="form-group"
    :aria-labelledby="'trimmingLabel' + count"
  >
    <label :id="'trimmingLabel' + count">
      Trimming <small> - Use your keyboard arrows for fine control</small>
    </label>
    <div class="row row-no-padding">
      <div class="col-xs-2">
        <label :for="'startPosition' + count">
          <small>Start</small>
        </label>
      </div>
      <div class="col-xs-8">
        <input
          :id="'startPosition' + count"
          v-model.number="trim.from"
          type="range"
          min="0"
          :max="maxTrim-minDuration"
          @change="trim.to = Math.max(trim.to, trim.from+minDuration)"
        >
      </div>
      <div class="col-xs-2 text-right">
        <small>{{ trim.from | time }}</small>
      </div>
    </div>
    <div class="row row-no-padding">
      <div class="col-xs-2">
        <label :for="'endPosition' + count">
          <small>End</small>
        </label>
      </div>
      <div class="col-xs-8">
        <input
          :id="'endPosition' + count"
          v-model.number="trim.to"
          type="range"
          :min="minDuration"
          :max="maxTrim"
          @change="trim.from = Math.min(trim.from, trim.to-minDuration)"
        >
      </div>
      <div class="col-xs-2 text-right">
        <small>{{ trim.to | time }}</small>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  input[type=range] {
    margin-top: 4px;
  }
</style>

<script>
export default {
  props: { 'trim': Object, 'count': String },
  data() {
    return {
      minDuration: 10,
      maxTrim: 7200-1
    };
  },
  watch: {
    trim: 'checkTrim'
  },
  mounted() {
    this.checkTrim();
  },
  methods: {
    checkTrim() {
      if (this.trim.to < 0) {
        this.trim.to = this.maxTrim;
      }
    }
  }
};
</script>
